import { forwardRef, memo } from 'react';

import type { SharedIconProps } from '../../../types/SharedIconProps';

import { Button, type ButtonProps } from '../Button';

export type IconButtonProps = Omit<
  ButtonProps,
  'icon' | 'text' | '__private'
> & {
  icon: SharedIconProps;
};

export const IconButton = memo(
  forwardRef<HTMLElement, IconButtonProps>(function IconButton(
    { icon, ...rest },
    ref,
  ) {
    return (
      <Button
        {...rest}
        ref={ref}
        __private={{ mode: 'icon' }}
        icon={{ ...icon }}
        text=""
      />
    );
  }),
);

IconButton.displayName = 'IconButton';
